// extracted by mini-css-extract-plugin
export var buttons = "_b6-0";
export var buttonsActive = "_b6-h";
export var cancelConfirm = "_b6-1";
export var closeButton = "_b6-2";
export var column = "_b6-3";
export var container = "_b6-4";
export var detailHeader = "_b6-6";
export var detailTitle = "_b6-7";
export var detailsContent = "_b6-5";
export var header = "_b6-8";
export var headerWithClose = "_b6-9";
export var icon = "_b6-a";
export var infoIcon = "_b6-c";
export var informationContainer = "_b6-b";
export var sideDrawer = "_b6-d";
export var sideDrawerOpen = "_b6-e";
export var stickyFooter = "_b6-f";
export var typeOption = "_b6-g";